import { isIE } from './isIE';
var polyfill = function (x) {
    x = +x;
    if (x === 0 || isNaN(x)) {
        return x;
    }
    return x > 0 ? 1 : -1;
};
export var mathSign = isIE() ? polyfill : Math.sign;
//# sourceMappingURL=mathSign.js.map